import * as React from "react";
import { Breadcrumbs } from "@grandvisionhq/common";
import { Container } from "@grandvisionhq/elements";
/* empty css                               */
const ProductCatalogBreadcrumbs = ({ breadcrumbs }) => {
  return /* @__PURE__ */ React.createElement(Container, { className: "product-catalog-breadcrumbs" }, /* @__PURE__ */ React.createElement(Breadcrumbs, { pages: breadcrumbs }));
};
export {
  ProductCatalogBreadcrumbs
};
//# sourceMappingURL=ProductCatalogBreadcrumbs.js.map
